<template lang="pug">
  div.about
    div.about-us-banner
      img.banner-image(src="//stance.oss-cn-hangzhou.aliyuncs.com/banner/about/about.png",
          alt="193 Pp Wall",
          style="object-position: 50% 50%")
    div.assay
      h3 拥护"THE UNCOMMON THREAD"为唯一信条
      p 我们在短短五年之内，将袜子打造成世界上最激动人心的配饰之一。Stance的品牌创始人将注意力放到了袜子 – 这个毫不起眼，甚至常常被人忽视的类目上。通过为这个被过分轻看的行业注入新的生命力，Stance引爆了一场艺术和自我表达的时尚盛宴，吸引了大批体育名人，时尚明星和潮流风向人物加入Stance家庭。他们，也拥有一个共同的名字：Punks & Poets（雅痞）。通过不懈的设计创新和持续的技术革新，Stance赢得了越来越多的关注。目前，你可以在全球超过40个国家的时尚潮流人士身上看到Stance的产品，它们被用来表达情感、彰显个性。
    VideoFrame
    LiveBy
    //- div.self-made-and-self-making
      h3 自主研发销售
      div.advantage-list
        Advantage.advantage(v-for="(item,$index) in advantages", :item="item", :key="$index")
    div.swiper
      SwiperCarousel(:list="list")
    //- FromThePress
    //- div.search-for-story
      div.story-text
        h3 WE SEARCH FOR THE STORIES OF SELF EXPRESSION AND DIRECT THE SPOTLIGHT ON THE CHARACTERS WHO ARE TRUE ORIGINALS. OUR PURPOSE IS TO IDENTIFY HUMAN CREATIVITY AND SHOWCASE THOSE WHO BROKE THE RULES AND WERE REWARDED.
    //- div.curators-of-originality
      h6 Punks & Poets
      h3 Curators Of Originality
      p The Punks & Poets are those who dare to be true to themselves and provide the heartbeat of our brand. Free thinking, brave, and passionate, they do things their own way and live by their own rules.
    //- VideoFrame
    Spokesman
</template>
<script>
import Advantage from '@/components/About/Advantage'
import SwiperCarousel from '@/components/About/SwiperCarousel'
import Spokesman from '@/components/About/Spokesman'
import VideoFrame from '@/components/About/VideoFrame'
import LiveBy from '@/components/About/LiveBy'
import FromThePress from '@/components/About/FromThePress'

export default {
  name: 'About',
  data () {
    return {
      advantages: [
        {
          title: '设计',
          desc: 'We live at the intersection of art and science, designing products that perform at the highest level while inspiring the human spirit.',
          img: 'https://s.stance.com/imager/media/pages/about/162/design_8538b6a7126668ee8697be3e7baf8f0f.jpg'
        },
        {
          title: '工艺',
          desc: 'It’s not rocket science, but we hired a rocket scientist anyway. We are writing the book on quality standardization. Why? Because innovation that doesn’t last is just a gimmick.',
          img: 'https://s.stance.com/imager/media/pages/about/162/design_8538b6a7126668ee8697be3e7baf8f0f.jpg'
        },
        {
          title: '材料',
          desc: 'We’re defining the future of knitwear, and have an unbridled passion for perfection. We start with the best, and if that’s not good enough, we develop our own proprietary fibers.',
          img: 'https://s.stance.com/imager/media/pages/about/162/design_8538b6a7126668ee8697be3e7baf8f0f.jpg'
        }
      ],
      list: [
        {
          img: 'https://s.stance.com/imager/media/pages/about/gallery/201/52B1209_d0195c43b0c25b5d3be0ee72b8c8ccdd.jpg'
        },
        {
          img: 'https://s.stance.com/imager/media/pages/about/gallery/204/52B2142_d0195c43b0c25b5d3be0ee72b8c8ccdd.jpg'
        },
        {
          img: 'https://s.stance.com/imager/media/pages/about/gallery/205/52B2168_d0195c43b0c25b5d3be0ee72b8c8ccdd.jpg'
        }
      ]
    }
  },
  components: {
    Advantage,
    SwiperCarousel,
    Spokesman,
    VideoFrame,
    LiveBy,
    FromThePress
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;
  }
.logo {
  width: 3rem;
  margin-bottom: 1rem;
}

.about-us-banner {
  position: relative;
    .banner-image {
      width: 100%;
      max-width: 100%;
      max-height: 60vh;
      object-fit: cover;
    }
}

.slogan {
  max-width: 83.33333%;
  margin: 0 auto;
  img {
    max-width: 100%;
  }
}

.assay {
  padding: 0 15px 3.75rem 15px;
  text-align: center;
  h3 {
    font-size: 2.29rem;
    text-transform: uppercase;
    margin-bottom: 0;
    font-family: akzidenz-grotesk-condensed;
    font-weight: bold;
    line-height: 1.1;
    color: #1a1a1a;
    padding: 1.87rem 0;
  }
  p {
    color: #7b7b82;
  }
}

.self-made-and-self-making {
  padding: 0 15px;
  h3 {
    font-size: 2.29rem;
    text-transform: uppercase;
    margin-bottom: 0;
    font-family: akzidenz-grotesk-condensed;
    font-weight: bold;
    line-height: 1.1;
    color: #1a1a1a;
    text-align: center;
    padding: 1.875rem 0 1.25rem 0;
  }
}

.search-for-story {
  padding: 14vw 0;
  .story-text {
    background-image: url('https://s3-us-west-1.amazonaws.com/stance.media/media/pages/about/healing-spirit-blue.jpg?mtime=20170223102357');
    background-size:cover;
    background-position: top;
    background-repeat: no-repeat;
    padding-top: 14vw;
    padding-bottom: 14vw;
    padding-left: 15px;
    padding-right: 15px;
  }

  h3 {
    color:#fff;
    font-size: 50px;
    font-size: 7vw;
    font-weight: 500;
    line-height: 1.3;
    font-family: akzidenz-grotesk-condensed;
    text-align: center;
    padding: 0 15px;
    margin: 0;
  }
}

.curators-of-originality {
  padding: 0 15px;
  margin-bottom:2.875rem;
  h6 {
    margin-bottom: 0;
    font-family: akzidenz-grotesk-condensed;
    font-weight: 400;
    line-height: 1.1;
    color: #1a1a1a;
    font-size: 1.14rem;
    text-transform: uppercase;
    text-align: center;
    margin: 0;
  }
  h3 {
    margin-bottom: 0;
    font-family: akzidenz-grotesk-condensed;
    font-weight: 400;
    line-height: 1.1;
    color: #1a1a1a;
    font-size: 2.29rem;
    text-align: center;
    margin: 0;
  }
  p {
    color: #3b3b3f;
    font-weight:300;
    font-size: 1.2rem;
    margin: 0;
    text-align: center;
    line-height: 1.4;
  }
}

.swiper {
  margin: 5px;
}

@media only screen and (min-width: 768px) {
  .assay {
    max-width: 50%;
    margin: 0 auto;
  }
  .self-made-and-self-making {
    max-width: 80rem;
    margin: 0 auto;
    .advantage-list {
      display: flex;
      flex-flow: row nowrap;
    }
    .advantage {
      flex: 1;
    }
  }
  .story-text {
    background-attachment: fixed;
    h3 {
      max-width: 66.66667%;
      margin: 0 auto;
      font-size: 3rem
    }
  }
  .curators-of-originality {
    max-width: 80rem;
    margin: 0 auto;
  }
}
</style>
